import { Toggle } from '@qbe/ads-blocks-forms';
import { Typography } from '@qbe/ads-core';
import React from 'react';

import { INDEMNITY_PERIOD_OPTIONS } from '~/constants/domain-specific';
import { useAppContent, useAppDispatch, useCoverDetails } from '~/hooks';
import { updateIndemnityPeriod } from '~/slices/coverDetails';
import { qalFormStartAction } from '~/thunks/analytics';
import { isFormStartStarted } from '~/utils/analytics/trackUtils';

import { ContextualHelpWithButton } from '../../components-ds/ContextualHelp/ContextualHelpWithButton';

interface IndemnityPeriodProps {}
const IndemnityPeriod: React.FC<IndemnityPeriodProps> = () => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.coverDetailsBusinessInterruption',
  });

  const dispatch = useAppDispatch();
  const { indemnityPeriod } = useCoverDetails();

  const handleFormStart = () => {
    if (!isFormStartStarted()) dispatch(qalFormStartAction());
  };

  return (
    <Toggle
      title={getTextContent('fields.indemnityPeriod.title')}
      titleSuffix={
        <ContextualHelpWithButton tracking="help: Indemnity period">
          <Typography>{getJSXContent('contextualhelpers.indemnityPeriod.description')}</Typography>
        </ContextualHelpWithButton>
      }
      subtitle={getTextContent('fields.indemnityPeriod.description')}
      name="indemnity_period"
      optionList={INDEMNITY_PERIOD_OPTIONS.map((o) => ({
        id: o.text,
        value: o.value,
        label: o.text,
        'data-track': 'Indemnity period',
        'data-track-value': 'capture',
        onChange: (event) => {
          const { value } = event.target;
          handleFormStart();
          dispatch(updateIndemnityPeriod(value === null ? value : Number(value)));
        },
        defaultChecked: o.value === String(indemnityPeriod),
      }))}
    />
  );
};

export default IndemnityPeriod;
